<template>
  <div id="scrollTop" class="JournalEntry md:h-screen bg-white text-black pt-12">
    <h1 class="text-transparent fixed">Architect Serving Launceston and Devonport</h1>
    <div class="flex flex-col h-full min-h-full">
      <div class="w-full">
        <div class="w-full lg:w-3/4 flex flex-wrap">

          <div class="w-full md:w-1/2 flex flex-wrap pt-24 md:pb-24 justify-start">
            <div class="ml-10 w-full mb-10 lg:mb-24 pr-5 lg:px-10 md:pb-20 h-auto lg:h-full">
              <h2 class="text-3xl lg:text-5xl">{{journalEntry.name}}</h2>
              <p class="text-xl">
                {{journalEntry.subHeading}}
              </p>
            </div>
          </div>

          <div class="w-full md:w-1/2 flex flex-wrap md:pt-24 pb-24 justify-start">
            <div class="pl-10 ml-10 w-full border-l border-black">
              <p class="w-2/3 md:w-1/2 text-xs lg:text-sm leading-6 md:leading-9">
                {{journalEntry.description}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        :style="{ backgroundImage: 'url(' + journalEntry.heroSrc + ')' }"
        class="w-full h-96 md:h-full bg-cover bg-center"
      >
      </div>
    </div>
    <div class="w-full pt-10 pl-10 pr-10 md:pt-40 md:pl-40 md:pr-10">
      <div class="w-full md:w-3/4">
        <div class="w-full">
          <div class="w-64 border-t border-black"></div>
        </div>
        <div
          v-for="(item, index) in journalEntry.items" :key="index"
          class="w-full mt-10"
        >
          <h6 class="text-sm uppercase mb-2">{{item.title}}</h6>
          <p class="text-sm">{{item.content}}</p>
        </div>
      </div>
    </div>

    <div class="w-full flex justify-end mb-24 px-10 mt-16">
      <div class="flex w-full md:w-64">
        <div class="w-1/3">
          <CustomButtonTwo @onClick="scrollToTop" dark>
            Top
          </CustomButtonTwo>
        </div>
        <div class="w-2/3 ml-8">
          <CustomButtonThree @onClick="goToNextProject" dark>
            Next
          </CustomButtonThree>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import CustomButtonTwo from '@/components/elements/CustomButtonTwo.vue'
import CustomButtonThree from '@/components/elements/CustomButtonThree.vue'
var VueScrollTo = require('vue-scrollto')

export default {
  name: 'journalentry',
  components: {
    CustomButtonTwo,
    CustomButtonThree
  },
  metaInfo () {
    return {
      title: 'Architecture in Devonport & Launceston | Starbox Architecture',
      meta: [
        {
          name: 'description',
          content: 'Starbox Architecture is a team of Devonport-based architects that serve individuals around Launceston. Visit us online to get started!'
        },
        {
          name: 'keywords',
          content: 'starbox,architecture,starbox architecture,tasmania,tasmanian,tasmanian architecture,tasmania architecture'
        }
      ]
    }
  },
  data () {
    return {
      journalEntry: {}
    }
  },
  computed: {
  },
  methods: {
    goToNextProject () {
      this.scrollToTop()
      this.$router.replace('/journalentry/' + this.journalEntry.nextId)
    },
    scrollToTop () {
      VueScrollTo.scrollTo('#scrollTop', '500', {})
    },
    getJournalEntry () {
      var toReturn = {}
      const updater = new URLSearchParams()
      updater.append('id', this.$route.params.id)
      axios.post(process.env.VUE_APP_ROOT_API + '/journal', updater).then(response => {
        var data = response.data
        toReturn = {
          id: data.id,
          name: data.name,
          subHeading: data.sub_heading,
          description: data.description,
          items: data.items,
          nextId: data.nextId,
          previousId: data.previousId
        }
        if (data.hero_image) toReturn.heroSrc = data.hero_image.path

        this.journalEntry = toReturn
      }).catch(error => {
        console.log('Error', error)
      })
    }
  },
  mounted () {
    this.getJournalEntry()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss">
  $sm: '640px';
  $md: '768px';
  $lg: '1024px';
  $xl: '1280px';
  $xxl: '1920px';
</style>
